import React from 'react';
import {StyleSheet, View} from 'react-native';
import Text from '../components/elements/Text';
import CommonStyles from './CommonStyles';
import {useTheme, useThemedStyles} from '../theme';
import {BaselineErrorIcon, CheckCircleIcon} from './SvgIcons';

// Rendered as elements (not called as functions) so the theme hooks inside
// are legal — react-native-toast-message renders whatever the config returns.
const ThemedToast = ({tone, message, image}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View
      style={[
        styles.toastContainer,
        tone === 'success' ? styles.greenBg : styles.redBg,
      ]}
    >
      {image ||
        (tone === 'success' ? <CheckCircleIcon /> : <BaselineErrorIcon />)}
      <Text
        variation="Body1SemiBold"
        color={colors.textOnAccent}
        style={styles.toastText}
      >
        {message}
      </Text>
    </View>
  );
};

export const toastConfig = {
  success: ({text1, props}) => (
    <ThemedToast tone="success" message={text1} image={props?.image} />
  ),
  error: ({text1, props}) => (
    <ThemedToast tone="error" message={text1} image={props?.image} />
  ),
};

// Theme-aware styles factory (docs/DARK-MODE.md).
const makeStyles = colors =>
  StyleSheet.create({
    toastContainer: {
      width: '90%',
      ...CommonStyles.flex_row,
      ...CommonStyles.items_center,
      ...CommonStyles.br_8,
      ...CommonStyles.p_16,
    },
    toastText: {
      ...CommonStyles.full_flex,
      ...CommonStyles.ml_8,
    },
    greenBg: {
      backgroundColor: colors.success,
    },
    redBg: {
      backgroundColor: colors.danger,
    },
  });
